import { render, staticRenderFns } from "./registerCompany.vue?vue&type=template&id=01449902&scoped=true&"
import script from "./registerCompany.vue?vue&type=script&lang=js&"
export * from "./registerCompany.vue?vue&type=script&lang=js&"
import style0 from "./registerCompany.vue?vue&type=style&index=0&id=01449902&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01449902",
  null
  
)

export default component.exports